import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['counter', 'checkbox']

  static values = {
    zeroCount: { type: String, default: null }
  }

  declare readonly counterTarget: HTMLElement
  declare readonly checkboxTargets: HTMLInputElement[]
  declare readonly zeroCountValue: string | null

  connect (): void {
    this.updateCounter()
    document.addEventListener('count-checkboxes:update', this.updateCounter.bind(this))
  }

  disconnect (): void {
    document.removeEventListener('count-checkboxes:update', this.updateCounter.bind(this))
  }

  updateCounter (): void {
    const checkedCount = this.checkboxTargets.filter(checkbox => checkbox.checked).length
    this.counterTarget.innerText = checkedCount.toString()

    if (checkedCount !== 0) {
      this.counterTarget.classList.remove('hidden')
    } else {
      this.handleZeroValue()
    }
  }

  private handleZeroValue (): void {
    if (this.hideZeroValue()) {
      this.counterTarget.classList.add('hidden')
    } else {
      this.counterTarget.innerText = this.zeroCountValue ?? '0'
    }
  }

  private hideZeroValue (): boolean {
    return this.zeroCountValue === null
  }
}
